// extracted by mini-css-extract-plugin
export default {"Backdrop":"BackDrop_Backdrop__2qv9s"};